import Vue from "vue";
import * as Sentry from "@sentry/vue";
import "./styles/main.scss";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import {
  formatCount,
  formatDistance,
  formatTime,
  formatWeight,
} from "./utils/common";

Vue.config.productionTip = false;

// environment/release come from the build (.env.<mode> and the Docker build arg), so every
// event says which site and which deploy it came from (#81).
Sentry.init({
  Vue: Vue,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  environment: process.env.VUE_APP_SENTRY_ENVIRONMENT,
  release: process.env.VUE_APP_SENTRY_RELEASE || undefined,
  integrations: [Sentry.browserTracingIntegration({ router })],
  tracesSampleRate: 0.5,
  // No sentry-trace/baggage headers on API calls. v8 adds them to same-origin requests, and
  // staging reaches the PRODUCTION backend through a same-origin /v1 proxy, so staging traces
  // would otherwise be recorded by the backend. Production (cross-origin API) never sent them.
  tracePropagationTargets: [],
  tracingOptions: { trackComponents: true },
});

Vue.filter("fdistance", (value) => {
  return formatDistance(value);
});

Vue.filter("fcount", (value) => {
  return formatCount(value);
});

Vue.filter("ftime", (value) => {
  return formatTime(value, { maxUnit: "day" });
});

Vue.filter("fcommasNumber", (value) => {
  return (value || 0).toLocaleString("en", { useGrouping: true });
});

Vue.filter("fweight", (value) => {
  return formatWeight(value);
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
